import { render, staticRenderFns } from "./NewB2bApplication.vue?vue&type=template&id=1927cffc&scoped=true&"
import script from "./NewB2bApplication.vue?vue&type=script&lang=js&"
export * from "./NewB2bApplication.vue?vue&type=script&lang=js&"
import style0 from "./NewB2bApplication.vue?vue&type=style&index=0&id=1927cffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1927cffc",
  null
  
)

export default component.exports